// Importing Foundation first
// ### Core
import 'what-input';

// Import all your components here
// But don't code inside this file.
// camelCase your file name
import './components/products-quantity';
import './components/unsubscribe-automatic-renew';
import './components/popup-first-order';
import './components/modal';

// Enables HMR for JS files imported here
if (module.hot) {
  module.hot.accept();
}

// Signed by Choosit!
console.log(`%c Made with ❤️ by Choosit! `, `background-color: #009ee0; color: white;`);
